import { apiCreate, apiGetOne, apiUpdate } from './ApiBaseActions';
export const API_UPDATE_PROFILE = 'API_UPDATE_PROFILE';
export const API_UPDATE_PROFILE_SUCCESS = 'API_UPDATE_PROFILE_SUCCESS';
export const API_UPDATE_PROFILE_NAME_AND_POSITION = 'API_UPDATE_PROFILE_NAME_AND_POSITION';
export const API_GET_ONE_PROFILE = 'API_GET_ONE_PROFILE';
export const API_GET_ONE_PROFILE_SUCCESS = 'API_GET_ONE_PROFILE_SUCCESS';
export const API_CREATE_PROFILE_RELATED_SOLUTION = 'API_CREATE_PROFILE_RELATED_SOLUTION';
/**
 * プロフィールを取得
 * @param meta
 * @returns {{payload: {}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiGetOneProfile = (meta) => apiGetOne(API_GET_ONE_PROFILE, '/profile', meta || {});
/**
 * プロフィールを更新
 * @param values
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiUpdateProfile = (values, meta) => apiUpdate(API_UPDATE_PROFILE, '/profile', values, meta || {});
/**
 * プロフィールを更新（氏名・役職のみ更新する簡易版）
 * @param values
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiUpdateProfileNameAndPosition = (values, meta) => apiUpdate(API_UPDATE_PROFILE_NAME_AND_POSITION, '/profile/name_and_position', values, meta || {});
/**
 *
 * @param values
 * @param meta
 * @returns {{payload: {data: *}, meta: *&{cancelPrevious: boolean, apiPath: *, fetch: string, type: *}, type: *}}
 */
export const apiCreateProfileRelatedSolution = (values, meta) => apiCreate(API_CREATE_PROFILE_RELATED_SOLUTION, '/profile/allow_related_solution', values, meta || {});
